import React, { useEffect, useState } from 'react';
import serviceCall from '../../store/serviceCall';
import _ from 'lodash';
import { SelectBox } from 'devextreme-react';

interface Customer {
  customerId: string;
  companyname: string;
}

interface CustomerSelectorProps {
  selectedCustomerId: string;
  onCustomerChange: (event: any) => void;
}

export default function CustomerSelector({
  selectedCustomerId,
  onCustomerChange,
}: CustomerSelectorProps): JSX.Element {
  const [customers, setCustomers] = useState<Array<Customer>>([]);

  useEffect(() => {
    serviceCall.getData(`Customer`).then(response => {
      if (response.status === 200) {
        setCustomers(response.data);
      } else {
        setCustomers([]);
      }
    });
  }, []);

  const customerOptions = [
    ..._.sortBy(
      customers.map(customer => ({
        id: customer.customerId,
        text: customer.companyname.toLowerCase(),
      })),
      'text',
    ),
  ];

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <SelectBox
        id="select-customer"
        items={customerOptions}
        value={selectedCustomerId}
        onValueChanged={onCustomerChange}
        displayExpr="text"
        valueExpr="id"
      />
    </div>
  );
}
